// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="use-our-health-apis-to-build-tools-that-help-veterans-manage-their-health-view-their-va-medical-records%2C-share-their-health-information%2C-and-determine-potential-eligibility-for-community-care.-while-these-apis-allow-greater-access-to-health-data%2C-they-do-not-currently-allow-submission-of-medical-claims.">Use our Health APIs to build tools that help Veterans manage their health, view their VA medical records, share their health information, and determine potential eligibility for community care. While these APIs allow greater access to health data, they do not currently allow submission of medical claims.</h2>
      <p>VA’s Health APIs use <a href="https://www.hl7.org/fhir/overview.html">HL7’s Fast Healthcare Interoperability Resources (FHIR) framework</a> for providing healthcare data in a standardized format. FHIR solutions are built from a set of modular components, called resources, which can be easily assembled into working systems that solve real world clinical and administrative problems.</p>
      <p>When you register for access to the Health APIs, you will be granted access to a synthetic set of data (provided by the MITRE Corporation) that mimics real Veteran demographics. The associated clinical resources include data generated from disease models covering up to a dozen of the most common Veteran afflictions. <Link to="/release-notes/health">Review the latest release notes</Link>.</p>
      <p><em>VA is a supporter of the <a href="https://www.carinalliance.com/">CARIN Alliance</a> Code of Conduct.</em></p>
    </div>
  );
};

export default MarkdownComponent;
